<template>
  <editable-text
    v-model="newTags"
    :no-data="$t('common.no_label')"
    :multi-select-options="tagOptions"
    :new-tag="newTag"
    @add-tag="createTag"
    @confirm="saveTags"
  ></editable-text>
</template>
<script>
import tagApi from '@/api/tag'
import optionApi from '@/api/option'

/**
 * 标签编辑器
 *
 * 支持事件：
 * 1. save(tagIds)
 */
export default {
  props: {
    /**
     * 标签的分类，如 User, Station
     * 不同的分类拥有自己的标签，分类名不限制
     */
    category: {
      type: String,
      default: null
    },
    /**
     * Tag 关联者的ID
     */
    ownerId: {
      type: String,
      default: null
    },
    /**
     * Tag 关联者的类型
     * 如：User, ChargeStation 需要匹配实际对象
     */
    ownerType: {
      type: String,
      default: null
    },
    /**
     * 运营商ID
     * 当前配置所属的运营商
     */
    serviceProviderId: {
      type: String,
      default: null
    },
    /**
     * 初始化标签
     */
    tags: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tagOptions: [],
      newTags: [],
      newTag: null
    }
  },
  watch: {
    // 标签变化后更新到 editable-text 的值
    tags(newValue) {
      this.newTags = newValue
    }
  },
  created() {
    this.fetchTags()
    this.newTags = this.tags // 初始化 tags
  },
  methods: {
    /**
     * 获取 tags 列表
     */
    fetchTags() {
      optionApi.getTags({ category: this.category }).then(response => {
        this.tagOptions = response.data.entities
      })
    },
    /**
     * 创建新的 tag，保存到 tag 列表
     *
     * @param {string} tag 新标签名
     */
    createTag(tag) {
      let params = {
        name: tag.name,
        category: this.category,
        service_provider_id: this.serviceProviderId
      }

      tagApi.createEntity(params).then(resp => {
        this.newTag = { id: resp.data.id, name: tag.name }
      })
    },
    /**
     * 保存 tags 到指定目标
     *
     * @param {Array<string>} tags 保存的 tags
     */
    saveTags(tags) {
      this.$emit('save', tags)
    }
  }
}
</script>
